import { Status } from "@enums/statistic";

export const CHART_COLOR: Record<Status, string> = {
  [Status.Delivered]: "#2d7319",
  [Status.Loaded]: "#e54865",
  [Status.InTransit]: "#01fcd6",
  [Status.AtReceiver]: "#00a6ff",
  [Status.SPu]: "#003cfd",
  [Status.InTransitToPU]: "#f50606",
  [Status.AtShipper]: "#f0c800",
  [Status.ScheduledPU]: "#d59c86",
};
